import React, {
  useEffect, useRef, useState,
} from 'react'
import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  IconButton,

} from '@material-ui/core'
import {
  withStyles,
} from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { CssFormControl } from 'src/utils/CustomInputs'
import { getAllAgeCategories, selectorAgeCategories } from 'src/app/slices/notificationSlice'
import {
  CloudUpload as CloudUploadIcon,
} from '@material-ui/icons'
import CustomToolbar from 'src/utils/CustomToolbar'
import DeleteIcon from 'src/icons/DeleteIcon'
import { editEvent, getEvent, selectorSingleEvent } from 'src/app/slices/eventSlice'
// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { useLocation } from 'react-router-dom'
import { useFormInput } from 'src/hooks'
// import { useFormInput } from 'src/hooks'
// import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor'
// import Fontbackgroundcolor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '50px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'orange',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const CssDatePicker = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(DatePicker)

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '20px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#f9b233',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'red',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#f9b233',
      },
    },
    '.MuiMenuItem-root': {
      backgroundColor: '#f9b233',
    },
  },
  MuiPaper: {
    root: {
      MuiMenu: {
        paper: {
          borderRadius: '50px',

        },
      },

    },
  },
  inputs: {
    width: '100%',
  },
  MuiListItem: {
    root: {
      '&.Mui-selected:hover': {
        backgroundColor: '#f9b233',
      },
    },
  },
  selectRol: {
    '& .MuiList-root': {
      borderRadius: '50px',
    },
  },
  menuItem: {
    '&::selected': {
      backgroundColor: 'red',
    },
    '&:hover': {
      backgroundColor: '#fef6e7',
    },

  },
  myInput: {
    border: 'none',
    outline: 'none !important',
    '&:focus': {
      border: 'none',
      outline: 'none !important',
    },
  },
  focusInput: {
    color: '#000',
    outline: 'none !important',
  },
  list: {
    borderRadius: '5px',
    top: '300px !important',
    border: '1px solid #f9b233',
  },
  datePicker: {
    '& .MuiPickersDatePickerRoot-toolbar': {
      backgroundColor: 'orange !important',
    },
  },
  addBtn: {
    display: 'flex',
    justifyContent: 'end',
  },
  inputFile: {
    display: 'none',
  },
  uploadLabel: {
    fontWeight: 700,
  },
  uploadItem: {
    margin: '20px 0',
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  filesWrapper: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  filesContainer: {
    display: 'flex',
    flexFlow: 'column',
  },
  editDialog: {
    '& .MuiDialog-paperWidthSm': {
      width: '80%',
      height: '400px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 20.6px 36px 20.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  dialogContentRoot: {
    padding: '8px 11px',
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#a5a5a5, #b5b5b5)',
    color: '#000',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      '@media (max-width: 960px)': {
        fontSize: '15px',
      },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '15px',
    marginTop: '10px',
    color: '#363853',
    '@media (max-width: 960px)': {
      fontSize: '14px',
    },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  editBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #f9b233',

    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#f9b233',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  item: {
    padding: '4px 20px',
    // height: '40px',
    // marginBotom: '45px',
  },
  addressWrap: {
    margin: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addressIconsWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'row',
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
  banner: {
    width: '20%',
  },
  richTextEditor: {
    '& .ck-editor__main > .ck-editor__editable': {
      minHeight: '200px',
      borderRadius: '40px',
      direction: 'rtl',
      // borderBottomLeftRadius: '20px',
      // borderBottomRightRadius: '20px',
    },
  },
}))

const EditForm = () => {
  const classes = useStyle()
  // const navigate = useNavigate()
  const dispatch = useDispatch()
  const ageCategories = useSelector(selectorAgeCategories)
  const singleEvent = useSelector(selectorSingleEvent)
  //   const state = useLocation().state || ''
  // const { eventId } = useParams()
  const state = useLocation().state || ''
  // const { eventId } = useParams()
  console.log(state, 'useLocation')

  const [eventAttachment, setEventAttachment] = useState(false)
  const [ClosingDate, handleCloseDateChange] = useState(state?.closingDate || moment())
  const [expireDate, handleDateChange] = useState(state?.expireDate || moment())

  const bannerRef = useRef(null)

  const allAgeCategories = [{
    ageCategoryId: ageCategories?.map((item) => item?.ageCategoryId).toString(),
    description: 'all',
    fromYear: 0,
    name: 'همه رده های سنی',
    toYear: 100,
  },
  ...ageCategories]

  const allEventAttachment = ['video/mp4', 'audio/mp3', 'image/jpeg',
    'image/png', 'pdf', 'zip', 'rar']

  const handleClose = () => {
    setEventAttachment(false)
  }

  const openEventAttachment = () => {
    setEventAttachment(true)
  }

  const Title = useFormInput(state?.title || '')
  const Subject = useFormInput(state?.subject)
  const Conditions = useFormInput(state?.conditions || null)
  const Awards = useFormInput(state?.awards || null)
  const Laws = useFormInput(state?.laws || null)
  const Category = useFormInput(state?.category?.ageCategoryId || [])
  const [mimeType, setMimeType] = useState('')
  const [attachmentTitle, setAttachmentTitle] = useState('')
  const [maxSize, setMaxSize] = useState('')
  const [bannerSrc, setBannerSrc] = React.useState(state.banner?.url || null)
  const [bannerFile, setBannerFile] = React.useState(state.banner || null)
  const [EventAttachmentInfos, setEventAttachmentInfos] = useState(singleEvent
    ?.eventAttachmentInfos || [])

  useEffect(() => {
    if (state) {
      dispatch(getEvent(+state?.id))
    }
  }, [])

  useEffect(() => {
    setEventAttachmentInfos(singleEvent?.eventAttachmentInfos)
  }, [singleEvent, bannerFile, bannerSrc])

  useEffect(() => {
    dispatch(getAllAgeCategories())
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData()
    const event = {
      id: state?.id,
      Title: Title?.value || null,
      Subject: Subject?.value || null,
      Laws: Laws?.value || null,
      Conditions: Conditions?.value || null,
      Awards: Awards?.value || null,
      Category: { AgeCategoryId: Category?.value } || null,
      ClosingDate: !ClosingDate ? ClosingDate.toISOString() : ClosingDate,
      expireDate: expireDate.toISOString() || null,
      EventAttachmentInfos: EventAttachmentInfos || null,
    }

    console.log(event, 'eventbanner')
    console.log(bannerFile, 'eventbanner')

    formData.append('event', JSON.stringify(event))
    formData.append('banner', bannerFile)

    dispatch(editEvent(formData))
  }

  const addAttachment = () => {
    if (attachmentTitle && mimeType) {
      setEventAttachmentInfos([
        ...EventAttachmentInfos,
        {
          id: Math.floor(Math.random() * 10000),
          mimeType,
          title: attachmentTitle,
          maxSize: maxSize * 1048576,
        },
      ])
      setEventAttachment(false)
      setMimeType('')
      setAttachmentTitle('')
      setMaxSize('')
    }
  }

  const deleteAttachment = (id) => {
    setEventAttachmentInfos((prevState) => prevState?.filter((at) => at?.id !== id))
  }

  const handleBannerChange = (e) => {
    const file = e?.target?.files?.[0]
    setBannerFile(file)
    console.log(file, 'filedfhdjtfgj')
    if (!file) return
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      setBannerSrc(reader?.result)
    }
  }

  // const handleChange = (e) => {
  //   setEventState({ [e.target.name]: e.target.value })
  // }

  return (
    <form onSubmit={handleSubmit}>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={2}>

            <Grid item xs={12} sm={6}>
              <CssTextField
                {...Title}
                fullWidth
                variant="outlined"
                id="title"
                name="title"
                label="عنوان رویداد"
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssTextField
                {...Subject}
                fullWidth
                variant="outlined"
                id="Subject"
                // onChange={handleChange}
                name="subject"
                // value={eventState?.subject}
                // onChange={(e) => setSubject(e?.target?.value)}
                label="موضوع رویداد"
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <CssTextField
                {...Laws}
                fullWidth
                variant="outlined"
                id="laws"
                name="laws"
                // onChange={handleChange}
                value={Laws?.value?.split('\\n').join('\r\n')}
                rows={4}
                multiline
              // value={eventState?.laws?.slice(1, -1).split('\\n').join('\r\n')}
                label="مجموعه قوانین"
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <CssTextField
                {...Conditions}
                fullWidth
                id="conditions"
                variant="outlined"
                name="conditions"
                label="مجموعه شروط"
                value={Conditions?.value?.split('\\n').join('\r\n')}
                // value={eventState?.conditions?.split('\\n').join('\r\n')}
                type="Conditions"
                rows={4}
                multiline
              />

            </Grid>
            <Grid item xs={12} sm={12}>
              <CssTextField
                {...Awards}
                fullWidth
                id="Awards"
                variant="outlined"
                name="awards"
                label="جوایز"
                type="Awards"
                value={Awards?.value?.split('\\n').join('\r\n')}
                rows={4}
                multiline
                InputProps={{
                }}
              />
            </Grid>
            <Grid item varia xs={12} md={6}>
              <CssFormControl variant="outlined" fullWidth>
                <InputLabel id="demo-mutiple-age-label">رده سنی</InputLabel>
                <Select
                  {...Category}
                  required
                  labelId="demo-mutiple-age-label"
                  id="demo-mutiple-age"
                  displayEmpty
                >
                  {allAgeCategories?.map((category, i) => (
                    <StyledMenuItem
                      key={i}
                      value={category?.ageCategoryId}
                    >
                      {category?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssFormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <CssDatePicker
                inputVariant="outlined"
                label="تاریخ بستن رویداد"
                fullWidth
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                DialogProps={{ className: classes.datePicker }}
                value={ClosingDate}
                onChange={handleCloseDateChange}
                ToolbarComponent={CustomToolbar}
                InputProps={{
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssDatePicker
                inputVariant="outlined"
                label="تاریخ انقضا"
                fullWidth
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={expireDate}
                onChange={handleDateChange}
                ToolbarComponent={CustomToolbar}
                DialogProps={{ className: classes.datePicker }}
                InputProps={{
                }}
              />
            </Grid>

            <Grid item varia xs={12} md={6} className={classes.filesContainer}>
              <div className={classes.filesWrapper}>
                <p style={{ fontSize: '16px' }}>فایل‌های رویداد</p>
                <Button onClick={openEventAttachment} color="primary" variant="contained" style={{ margin: '20px 15px' }}>
                  اضافه کردن
                </Button>
              </div>
              {EventAttachmentInfos?.length
                ? EventAttachmentInfos?.map((et) => (
                  <>
                    <div
                      key={et?.id}
                      className={classes.addressWrap}
                    >
                      <p>{et?.title}</p>
                      <div
                        className={classes.addressIconsWrap}
                      >
                        <IconButton onClick={() => deleteAttachment(et?.id)}>
                          <DeleteIcon className={classes.icons} />
                        </IconButton>
                      </div>

                    </div>
                    <Divider />
                  </>
                )) : null}
            </Grid>

            <Grid item xs={12} md={6} classes={{ root: classes.uploadItem }}>
              <>
                <div>
                  <span style={{ margin: '20px 5px 20px 20px' }} className={classes.uploadLabel}>تصویر بنر</span>
                  <label htmlFor="Banner">
                    <input
                      accept="application/pdf, image/jpg, image/jpeg, image/png, video/mp4"
                      className={classes.inputFile}
                      id="Banner"
                    // multiple
                      type="file"
                    //   value={}
                      onChange={handleBannerChange}
                      ref={bannerRef}
                    />
                    <Button
                      component="span"
                      classes={{ root: classes.uploadButton }}
                      variant="outlined"
                      color="primary"
                      className={classes.button}
                      endIcon={<CloudUploadIcon />}
                      ref={bannerRef}
                    >
                      انتخاب فایل
                    </Button>
                  </label>
                </div>
                {bannerSrc && (
                <img
                  alt="banner"
                  className={classes.banner}
                  src={bannerSrc}
                />
                )}
              </>
            </Grid>

            <Dialog
              className={classes.editDialog}
              open={eventAttachment}
              onClose={() => handleClose(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">رویداد جدید</DialogTitle>
              <DialogContent
                classes={{ root: classes.dialogContentRoot }}
              >
                <Grid
                  item
                  xs={12}
                  container
                >
                  <Grid
                    item
                    md={12}
                    xs={12}
                    classes={{ root: classes.item }}
                    // style={{ margin: '40px 0 3px' }}
                  >
                    <CssFormControl variant="outlined" fullWidth style={{ margin: '20px 0 5px' }}>
                      <InputLabel id="demo-mutiple-event-label">نوع فایل</InputLabel>
                      <Select
                        required
                        labelId="demo-mutiple-event-label"
                        id="demo-mutiple-age"
                  // multiple
                        // {...MimeType}
                        value={mimeType}
                        onChange={(e) => setMimeType(e.target.value)}
                      >
                        {allEventAttachment?.map((type, i) => (
                          <StyledMenuItem
                            key={i}
                            value={type}
                          >
                            {type}
                          </StyledMenuItem>
                        ))}
                      </Select>
                    </CssFormControl>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    xs={12}
                    classes={{ root: classes.item }}
                  >
                    <CssTextField
                      value={attachmentTitle}
                      onChange={(e) => setAttachmentTitle(e.target.value)}
                      fullWidth
                      label="عنوان فایل پیوستی"
                      id="Title"
                      margin="normal"
                      name="Title"
                      type="text"
                      variant="outlined"
                      inputProps={{
                        maxLength: 10,
                        pattern: '[0-9]*',
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    classes={{ root: classes.item }}
                  >
                    <CssTextField
                      value={maxSize}
                      onChange={(e) => setMaxSize(e.target.value)}
                      fullWidth
                      label="حداکثر سایز مربوطه (mb)"
                      margin="normal"
                      name="MaxSize"
                      type="number"
                      variant="outlined"
                      inputProps={{
                        maxLength: 11,
                        pattern: '[0-9]*',
                      }}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions className={classes.dialogButtons}>
                <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
                  لغو
                </Button>
                <Button
                  onClick={addAttachment}
                  className={classes.editBtn}
                  autoFocus
                >
                  ایجاد
                </Button>
              </DialogActions>
            </Dialog>

            <Grid item xs={12} className={classes.addBtn}>
              <Button color="primary" variant="contained" type="submit">
                ثبت
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default EditForm
